import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-neutral-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl" style={{ color: "oklch(var(--primary-500))" }}></i>
              </div>
              <span className="text-lg font-bold" style={{ fontFamily: "var(--font-heading)" }}>白云视频</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              高清不卡顿的免费在线影视平台，海量电影电视剧等你来看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              视频分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">首页</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">关于我们</Link>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">服务条款</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              友情链接
            </h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-400">西瓜视频</span>
              <span className="text-sm text-foreground-400">糖豆视频</span>
              <span className="text-sm text-foreground-400">小蓝视频</span>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            © 2026 白云视频 版权所有 | 本站内容仅供学习和交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}